
import * as React from "react"
const WebSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M325.3 304c-3.7 0-7.4-1.3-10.4-3.9-6.7-5.8-7.5-15.9-1.7-22.6l23.1-26.9-23.1-26.9c-5.8-6.7-5-16.8 1.7-22.6 6.7-5.8 16.8-5 22.6 1.7l32 37.3c5.1 6 5.1 14.8 0 20.8l-32 37.3c-3.2 3.9-7.7 5.8-12.2 5.8zM186.7 304c-4.5 0-9-1.9-12.2-5.6l-32-37.3c-5.1-6-5.1-14.8 0-20.8l32-37.3c5.7-6.7 15.9-7.5 22.6-1.7 6.7 5.8 7.5 15.9 1.7 22.6l-23.1 26.9 23.1 26.9c5.8 6.7 5 16.8-1.7 22.6-3 2.4-6.7 3.7-10.4 3.7zM236.4 333.6c-8.6-2-14-8.6-12-17.2l32-138.7c2-8.6 10.6-13.9 19.2-12 8.6 2 14 10.6 12 19.2l-32 138.7c-1.9 8.5-10.4 12-19.2 10z" />
    <path d="M474.7 85.3H37.3C16.9 85.3 0 102.2 0 122.7v288C0 431.1 16.9 448 37.3 448h163.4c-2.5 10.7-9.2 28-26.9 45.8-3.1 3.1-4 7.6-2.3 11.6 1.6 4 5.5 6.6 9.9 6.6h149.3c4.3 0 8.2-2.6 9.9-6.6 1.6-4 .7-8.6-2.3-11.6-17.7-17.7-24.6-35.1-27.2-45.8h163.6c20.5 0 37.3-16.9 37.3-37.3v-288c0-20.5-16.9-37.4-37.3-37.4zm-5.4 289.4H42.7V128h426.7v246.7z" />
  </svg>
)
export default WebSvg